cobalt-tooltip {
  display: inline-block;
}

cobalt-tooltip core-tooltip {
  --information-button-padding: var(--number-spacing-5xsmall);
  --information-button-radius: var(--number-radius-2xsmall);
}

.core-tooltip-content {
  --tooltip-radius: var(--number-spacing-xsmall);
}
